
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40 20c0 11.016-8.984 20-20 20S0 31.016 0 20 8.984 0 20 0s20 8.984 20 20zm-21.297-1v-2.742h4.64a.627.627 0 00.626-.625.627.627 0 00-.625-.625h-5.266a.627.627 0 00-.625.625v7.984c0 .344.281.625.625.625h5.266a.627.627 0 00.625-.625.627.627 0 00-.625-.625h-4.64V20.25h4.64a.627.627 0 00.625-.625.627.627 0 00-.625-.625h-4.64zm12.078 2.39c0-.343.29-.617.633-.609a.625.625 0 01.61.633 2.892 2.892 0 01-2.876 2.82h-.765a2.877 2.877 0 01-2.875-2.875v-3.484A2.877 2.877 0 0128.383 15h.765a2.892 2.892 0 012.875 2.82.62.62 0 11-1.242.024 1.627 1.627 0 00-1.625-1.594h-.765c-.899 0-1.625.727-1.625 1.625v3.484c0 .899.726 1.625 1.625 1.625h.765c.883 0 1.61-.71 1.625-1.593zm-17.89-.546a2.918 2.918 0 002.882-2.914 2.932 2.932 0 00-2.921-2.922H9.625a.614.614 0 00-.594.437.525.525 0 00-.031.188v7.984c0 .344.281.625.625.625a.627.627 0 00.625-.625v-2.773h1.047l2.39 3.023a.607.607 0 00.493.242c.133 0 .265-.039.383-.132a.628.628 0 00.101-.875l-1.773-2.258zm-.032-4.578c.914 0 1.664.742 1.664 1.664 0 .922-.75 1.664-1.664 1.672h-2.601v-3.336h2.601z"}})])
          )
        }
      }
    